import { Navigate } from 'react-router-dom';
import { AppLayout } from '../../components/templates/AppLayout/AppLayout';
import { Header } from '../../components/layout/Header';
import { Sidebar } from '../../components/Sidebar';
import { PageContent } from '../../components/templates/PageContent';
import { PageHeader } from '../../components/templates/PageHeader';
import { LiveRegion } from '../../components/atoms/LiveRegion/LiveRegion';
import { Text } from '../../components/atoms/Typography';
import { useTranslation } from '../../i18n/useTranslation';
import { useActiveAquarium } from '../../contexts/AquariumContext';
import { useAquariums } from '../../hooks/useAquariums';

/**
 * Former Settings → Camera sources. The cameras now live in the aquarium's
 * integrations (/aquariums/:id/integrations/camera); this route keeps old
 * links and bookmarks working by sending them to the active aquarium's tab
 * (without an aquarium: to the aquarium list).
 */
export function CameraSourcesPage() {
  const { t } = useTranslation();
  const { isLoading, error } = useAquariums();
  const { aquariums, activeAquariumId } = useActiveAquarium();

  if (activeAquariumId) {
    return <Navigate replace to={`/aquariums/${encodeURIComponent(activeAquariumId)}/integrations/camera`} />;
  }
  if (!isLoading && (error || aquariums.length === 0)) {
    return <Navigate replace to="/aquariums" />;
  }
  return (
    <AppLayout
      header={<Header />}
      sidebar={<Sidebar />}
      main={
        <PageContent width="default">
          <PageHeader title={t('cameraSources.title')} />
          <LiveRegion busy>
            <Text>{t('cameraSources.loading')}</Text>
          </LiveRegion>
        </PageContent>
      }
    />
  );
}

export default CameraSourcesPage;
